import AppToast from "@/app/components/lib/toast/AppToast";
import { IUploadErr, ReasonType, fileNameAndExt } from "./upload";
import { truncateString } from "@/utils/functions/functions";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: () => void;
  message: IUploadErr[];
}

const ToastForUpload: React.FC<Props> = ({ show, setShow, message }) => {
  const t = useTranslation();
  const reasonMsg = message.map((m) => {
    const { name, ext } = fileNameAndExt(m.name);
    const truncName = truncateString(name, 5);
    const truncExt = truncateString(ext, 5);
    return m.reason === ReasonType.size
      ? `${truncName}${truncExt}: ${t.size_more_2MB}`
      : `${truncName}${truncExt}: [${truncExt}] ${t.ext_not_supported}`;
  });

  return (
    <AppToast
      show={show}
      setShow={setShow}
      danger
      message={
        <>
          <div>{t.not_uploaded}</div>
          {reasonMsg.map((m, key) => (
            <div key={key}>
              <bdi>{m}</bdi>
            </div>
          ))}
        </>
      }
    />
  );
};

export default ToastForUpload;
